import React from 'react';
import { useLocation } from "react-router-dom";
import {  Link } from 'react-router-dom'
import './MedicalHistoryNav.css';
import { PATIENT_MEDICAL_HISTORY_PAGES } from './medicalHistoryPages';
import moment from 'moment';

var UserData;
export default function MedicalHistoryNav() {
  debugger
  UserData = JSON.parse(localStorage.getItem("UData"));
  let Clinic =  localStorage.getItem("ClinicName");
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  let MainGender = localStorage.getItem("PatientGender");
  return (
        <>
          <div className="ox-mh__banner">
            <div>
              <h2 className="ox-mh__title">Medical History &amp; Questionnaire</h2>
              <p className="ox-mh__sub">
                {UserData?.firstName} {UserData?.lastName}
                {UserData?.birthday ? ` · DOB ${moment(UserData.birthday).format("DD-MMM-YYYY")} (${UserData?.age})` : ""}
                {UserData?.gendercodeName ? ` · ${UserData.gendercodeName}` : ""}
              </p>
            </div>
          </div>
          <section className="ox-mh__tabsWrap">
            <ul className="ox-mh__tabs">

              { Clinic != "Hull" ?
              <li className={splitLocation[1] === "MedicalHistory" ? "is-active" : ""}>
                <Link to='/MedicalHistory' className='ox-mh__tab'>Patient Medical History</Link>
              </li>
                : null}

            {/* { Clinic === "Hull" ?

            <li className={splitLocation[1] === "MedicalHistory" ? "is-active" : ""}>
                            <Link to='/Medical_History' className='ox-mh__tab'>Patient Medical History</Link>
                          </li>
              : null
              } */}


               {Clinic === "Hull" ? (
                (MainGender === 1 || MainGender === "1") ? (
                  // Medical_History male
                  <li className={splitLocation[1] === "MedicalHistory" ? "is-active" : ""}>
                                          <Link to='/MedicalSocialHistory2' className='ox-mh__tab'>Patient Medical History</Link>
                                        </li>
                ) : (
                  // Medical_History Female
              <li className={splitLocation[1] === "MedicalHistory" ? "is-active" : ""}>
                                          <Link to='/MedicalSocialHistory' className='ox-mh__tab'>Patient Medical History</Link>
                                        </li>
                )
              ) : null}
    
              {/* <li className={splitLocation[1] === "TreatMentWithUs" ? "is-active" : ""}>
                <Link to='/TreatMentWithUs' className='ox-mh__tab' >Treatment with Us</Link>
              </li> */}

              <li className={splitLocation[1] === "PreviousFertilityTreatment" ? "is-active" : ""}>
                <Link to='/PreviousFertilityTreatment' className='ox-mh__tab' >Previous Fertility Treatment</Link>
              </li>
              <li className={splitLocation[1] === "PreviousPregnancy" ? "is-active" : ""}>
                <Link to='/PreviousPregnancy' className='ox-mh__tab' > Previous Pregnancy</Link>
              </li>
              <li className={splitLocation[1] === "Allergies" ? "is-active" : ""}>
                <Link to='/Allergies' className='ox-mh__tab' >Allergies</Link>
              </li>
              <li className={splitLocation[1] === "PreviousProcedure" ? "is-active" : ""}>
                <Link to='/PreviousProcedure' className='ox-mh__tab' >Previous Procedure</Link>
              </li>
              <li className={splitLocation[1] === "Prescription" ? "is-active" : ""}>
                <Link to='/Prescription' className='ox-mh__tab' >Prescription</Link>
              </li>
              <li className={splitLocation[1] === "DrugReminder" ? "is-active" : ""}>
                <Link to='/DrugReminder' className='ox-mh__tab' >Drug Reminder</Link>
              </li>


            </ul>
          </section>
        </>
  )
}